import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getBranches = createAsyncThunk<any, any>(
  'getBranchesFromApi',
  async ({page = 0, pageSize = 10, searchQuery, vendorStatus}: any) => {
    let url = `user/vendors?page=${page}&pageSize=${pageSize}`;
    if (searchQuery && vendorStatus) {
      url += `&searchQuery=${searchQuery}&vendorStatus=${vendorStatus}`;
    } else if (searchQuery) {
      url += `&searchQuery=${searchQuery}`;
    } else if (vendorStatus) {
      url += `&vendorStatus=${vendorStatus}`;
    }

    const response = await api.get(url, {customFlag: true});
    const branches = response?.data?.included?.filter((d) => d.type === 'vendorUser');
    const profile = response.data.data.attributes;
    const profileId = response.data.data.id;
    const pagination = response?.data?.pagination;
    return {branches, profile, profileId, pagination};
  }
);

export const getBestSelling = createAsyncThunk<any, any>(
  'getBestSelling',
  async ({vendorId, pageSize = 10}: any) => {
    try {
      const response = await api.get(
        `dashboard/vendor-assortment?vendorId=${vendorId}&page=1&pageSize=${pageSize}`
      );
      const {vendorAssortments} = response?.data?.data ?? {};
      return vendorAssortments?.data?.slice(0, 5);
    } catch (e: any) {
      console.warn(e);
    }
  }
);
